import { render, staticRenderFns } from "./VaccinePolyAssestment.vue?vue&type=template&id=b5790fe6&scoped=true"
import script from "./VaccinePolyAssestment.vue?vue&type=script&lang=js"
export * from "./VaccinePolyAssestment.vue?vue&type=script&lang=js"
import style0 from "./VaccinePolyAssestment.vue?vue&type=style&index=0&id=b5790fe6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5790fe6",
  null
  
)

export default component.exports